export const OPEN_CONTACT_US_MODAL = 'OPEN_CONTACT_US_MODAL';
export const CLOSE_CONTACT_US_MODAL = 'CLOSE_CONTACT_US_MODAL';
